import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/Census/high-risk`;

/**
 * Obtiene el listado de pacientes marcados como alto riesgo por cualquiera
 * de los 3 flags (PPV-ER, LACE, BH Status).
 *
 * No está atado a un evento hospitalario puntual — es un estado del paciente.
 * El scope por rol lo aplica el backend.
 *
 * @param {Object} [filters]
 * @param {string}  [filters.cipId]       - CIP específico.
 * @param {number}  [filters.locationId]  - Center (respeta scope por rol).
 * @param {string}  [filters.searchName]  - LIKE sobre nombre completo.
 * @param {string}  [filters.dateOfBirth] - DOB exacto (YYYY-MM-DD).
 * @param {boolean} [filters.onlyActive]  - default true en el backend. false incluye históricos.
 * @param {boolean} [filters.ppvEr]       - Filtrar por flag PPV-ER.
 * @param {boolean} [filters.lace]        - Filtrar por flag LACE.
 * @param {boolean} [filters.bhStatus]    - Filtrar por flag Behavioral Health.
 *
 * Ejemplo de llamada:
 * GET /api/Census/high-risk?ppvEr=true&bhStatus=true
 *
 * Respuesta exitosa (200):
 * [
 *   {
 *     "highRiskId": 20,
 *     "cipId": "17500292167",
 *     "ppvEr": false,
 *     "lace": true,
 *     "bhStatus": true,
 *     "flagsActive": 2,
 *     "firstSeen": "2026-04-23T00:00:00",
 *     "lastSeen": "2026-04-23T00:00:00",
 *     "status": 1,
 *     "fullName": "ETHEREDGE, MICHELLE",
 *     "dateOfBirth": "1963-07-27T00:00:00",
 *     "gender": "F",
 *     "phoneNumber": "(561) 317-4371",
 *     "mobileNumber": "(561) 317-4371",
 *     "memberEmail": "METHEREDGE20@GMAIL.COM",
 *     "locationId": 5,
 *     "medicalCenter": "Lake Worth",
 *     "locationAddress": "3155 LAKE WORTH RD, Palm Springs, FL - 33461-6917, Palm Beach"
 *   }
 * ]
 *
 * `flagsActive` (0-3) es la criticidad (el SP ya ordena por este campo desc).
 * `status = 1` es activo; con onlyActive=false pueden venir con status != 1.
 *
 * Posibles errores:
 * 401 Sin token o token inválido.
 * 500 Excepción en el SP o pipeline (el repo retorna lista vacía para no romper el front).
 */
export const getHighRiskPatients = async (filters = {}) => {
  try {
    const params = buildParams(filters);
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching high risk patients:", error);
    throw error;
  }
};

// Descarta valores vacíos para que axios no los envíe como query params.
// Los booleanos false sí se envían cuando el caller los declara explícitamente.
const buildParams = (filters) => {
  const params = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    params[key] = value;
  });
  return params;
};
